import { SpanExporter } from '@opentelemetry/sdk-trace-web';
import { BatchSpanProcessorBase, } from './batch-span-processor-base';
interface BatchSpanProcessorConfig {
    maxExportBatchSize?: number;
    maxQueueSize?: number;
    scheduledDelayMillis?: number;
    exportTimeoutMillis?: number;
    disableAutoFlushOnDocumentHide?: boolean;
}

export class AureliaBatchSpanProcessor extends BatchSpanProcessorBase<SpanExporter> {
    private _visibilityChangeListener?: () => void;
    private _pageHideListener?: () => void;

    constructor(_exporter: SpanExporter,  config?: BatchSpanProcessorConfig) {
        super(_exporter, config);
        this.onInit(config);
    }
        private onInit(config?: BatchSpanProcessorConfig): void {
        if (config?.disableAutoFlushOnDocumentHide !== true && typeof document !== 'undefined') {
            this._visibilityChangeListener = () => {
                if (document.visibilityState === 'hidden') {
                    void this.forceFlush();
                }
            };
            this._pageHideListener = () => {
                void this.forceFlush();
            };
            document.addEventListener('visibilitychange', this._visibilityChangeListener);
            // use 'pagehide' event as a fallback for Safari; see https://bugs.webkit.org/show_bug.cgi?id=116769
            document.addEventListener('pagehide', this._pageHideListener);
        }
    }

    onShutdown(): void {
        if (typeof document !== 'undefined') {
            if (this._visibilityChangeListener) {
                document.removeEventListener('visibilitychange', this._visibilityChangeListener);
            }
            if (this._pageHideListener) {
                document.removeEventListener('pagehide', this._pageHideListener);
            }
        }
    }
    public forceFlush(): Promise<void> {
        return super.forceFlush();
    }

}
